<template>
  <section class="e-requisition" id="print-container" v-loading="loading">
    <table style="width: 100%">
      <thead>
        <tr>
          <td>
            <div class="page-header">
              <div
                class="report-header"
                v-if="
                  this.sendOutData ||
                  this.sendOutData.patient_info ||
                  (getProfileData && getProfileData.lab)
                "
              >
                <table>
                  <tbody>
                    <tr>
                      <td style="vertical-align: top">
                        <div class="address-part">
                          <div style="width: 40%">
                            <div
                              class="logo"
                              v-if="
                                getProfileData.lab &&
                                getProfileData.lab.lab_code &&
                                getProfileData.lab.lab_code == 'DLW'
                              "
                            >
                              <img
                                src="@/assets/images/dlw-logo-sendout.svg"
                                alt="labsquire-logo"
                              />
                            </div>
                            <div
                              class="logo"
                              v-if="
                                getProfileData.lab &&
                                getProfileData.lab.lab_code &&
                                (getProfileData.lab.lab_code == 'MHC' ||
                                  getProfileData.lab.lab_code == 'MICROGEN')
                              "
                            >
                              <img
                                src="@/assets/images/mgh-logo-sendout.svg"
                                alt="labsquire-logo"
                                class="img-fluid"
                              />
                            </div>
                          </div>
                          <div
                            class="address"
                            v-if="
                              getProfileData.lab &&
                              getProfileData.lab.lab_code &&
                              getProfileData.lab.lab_code == 'DLW'
                            "
                          >
                            <p data-v-5293112a="" class="sub-line">
                              Dev Lab Werks,
                              <span
                                style="width: 2px; display: inline-block"
                              ></span>
                              234 Aquarius Drive,
                              <br />
                              Suite 100, 111, Homewood , ALABAMA 35209 .
                              <br />
                              Mail: info@devlabwerks.com
                            </p>
                            <p data-v-5293112a="" class="sub-line">
                              Website:
                              <a data-v-5293112a="">www.devlabwerks.com </a>
                              | Phone:
                              <a data-v-5293112a=""> +1 (205)-994-8266</a>
                              | Fax:
                              <a data-v-5293112a=""> 205-201-4797</a>
                            </p>
                          </div>
                          <div
                            class="address"
                            v-if="
                              getProfileData.lab &&
                              getProfileData.lab.lab_code &&
                              (getProfileData.lab.lab_code == 'MHC' ||
                                getProfileData.lab.lab_code == 'MICROGEN')
                            "
                          >
                            <p data-v-5293112a="" class="sub-line">
                              MicroGen Health Inc,
                              <span
                                style="width: 0px; display: inline-block"
                              ></span>
                              14225 Sullyfield Circle , Suite E ,

                              <br />
                              Chantilly, Virginia 20151 .
                              <br />
                              orders@microgenhealth.com
                            </p>
                            <p data-v-5293112a="" class="sub-line">
                              Website:
                              <a data-v-5293112a="">www.microgenhealth.com </a>
                              | Phone:
                              <a data-v-5293112a="">+1 571-775-1973</a>
                              | Fax:
                              <a data-v-5293112a="">+1 571-775-2012</a>
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="order-part">
                          <table
                            data-v-2f0381d8=""
                            class="steps-inner-form mb-05"
                          >
                            <tbody>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">
                                  Sendout ID
                                </td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td data-v-2f0381d8="" class="value">
                                  {{ this.sendOutData.sendout_id }}
                                </td>
                              </tr>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">
                                  Accession ID
                                </td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td data-v-2f0381d8="" class="value">
                                  {{ this.sendOutData.accession_id }}
                                </td>
                              </tr>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">
                                  Patient Name
                                </td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td
                                  data-v-2f0381d8=""
                                  class="value"
                                  v-if="
                                    this.sendOutData &&
                                    this.sendOutData.patient_info &&
                                    this.sendOutData.patient_info.middle_name
                                  "
                                >
                                  {{
                                    this.sendOutData &&
                                    this.sendOutData.patient_info
                                      ? this.sendOutData.patient_info
                                          .first_name +
                                        " " +
                                        this.sendOutData.patient_info
                                          .middle_name +
                                        " " +
                                        this.sendOutData.patient_info.last_name
                                      : "--"
                                  }}
                                </td>
                                <td data-v-2f0381d8="" class="value" v-else>
                                  {{
                                    this.sendOutData &&
                                    this.sendOutData.patient_info
                                      ? this.sendOutData.patient_info
                                          .first_name +
                                        " " +
                                        this.sendOutData.patient_info.last_name
                                      : "--"
                                  }}
                                </td>
                              </tr>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">DOB</td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td data-v-2f0381d8="" class="value">
                                  {{
                                    formatDate(
                                      (this.sendOutData &&
                                        this.sendOutData.patient_info &&
                                        this.sendOutData.patient_info
                                          .date_of_birth) ||
                                        "--"
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">Gender</td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td data-v-2f0381d8="" class="value">
                                  {{
                                    this.sendOutData &&
                                    this.sendOutData.patient_info &&
                                    this.sendOutData.patient_info.gender
                                  }}
                                </td>
                              </tr>
                              <tr data-v-2f0381d8="" class="form-input-view">
                                <td data-v-2f0381d8="" class="label">State</td>
                                <td data-v-2f0381d8="" class="divider">:</td>
                                <td data-v-2f0381d8="" class="value">
                                  {{
                                    this.sendOutData &&
                                    this.sendOutData.patient_info &&
                                    this.sendOutData.patient_info.state
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <h1 class="page-title">Sendouts</h1>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="page-header-space"></div>
          </td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <div
              class="each-step patient-information"
              v-if="this.sendOutData && this.sendOutData.patient_info"
            >
              <table>
                <tbody>
                  <tr>
                    <td colspan="4">
                      <h3 class="step-title">PATIENT INFORMATION</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">First Name </span>
                        <span class="value">
                          {{
                            convertToUppercase(
                              this.sendOutData &&
                                this.sendOutData.patient_info.first_name
                            ) || "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">Middle Name </span>
                        <span class="value">
                          {{
                            convertToUppercase(
                              this.sendOutData &&
                                this.sendOutData.patient_info.middle_name
                            ) || "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">Last Name </span>
                        <span class="value">
                          {{
                            convertToUppercase(
                              this.sendOutData &&
                                this.sendOutData.patient_info.last_name
                            ) || "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">Gender</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.gender) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="each-item">
                        <span class="name">Date of Birth </span>
                        <span class="value">
                          {{
                            formatDate(
                              this.sendOutData &&
                                this.sendOutData.patient_info.date_of_birth
                            ) || "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">EMR # </span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.emr) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Mobile Number </span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.home_phone) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Phone Number </span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.work_phone) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="each-item">
                        <span class="name">Email</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.email) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Address Line 1 </span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.address_line_1) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Address Line 2 </span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.address_line_2) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Zip</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.zip) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="each-item">
                        <span class="name">State</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.state) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">City</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.city) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Race</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.race) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Ethnicity</span>
                        <span class="value">
                          {{
                            (this.sendOutData &&
                              this.sendOutData.patient_info.ethnicity) ||
                            "--"
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="each-step patient-information" v-if="this.sendOutData">
              <table>
                <tbody>
                  <tr>
                    <td colspan="4">
                      <h3 class="step-title">CASE INFORMATION</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%">
                      <div
                        class="each-item"
                        v-if="
                          this.sendOutData &&
                          this.sendOutData.case_types &&
                          this.sendOutData.case_types.length
                        "
                      >
                        <span class="name">Case Type</span>
                        <span
                          class="value case-type"
                          v-for="(caseType, index) of this.sendOutData
                            .case_types"
                          :key="index"
                        >
                          <span>{{ caseTypeMap[caseType] }}</span>
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div
                        class="each-item"
                        v-if="this.sendOutData && this.sendOutData.lab"
                      >
                        <span class="name">Laboratory</span>
                        <span class="value">
                          {{ this.sendOutData.lab.name || "--" }}
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">Collection Date </span>
                        <span class="value">
                          {{
                            momentWithTimezone(
                              this.sendOutData.collection_date,
                              "MM-DD-yyyy"
                            )
                          }}
                        </span>
                      </div>
                    </td>
                    <td style="width: 25%">
                      <div class="each-item">
                        <span class="name">Received Date</span>
                        <span class="value">
                          {{
                            momentWithTimezone(
                              this.sendOutData.received_date,
                              "MM-DD-yyyy"
                            )
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        class="each-item"
                        v-if="this.sendOutData && this.sendOutData.hospital"
                      >
                        <span class="name">Ordering Facility </span>
                        <span class="value">
                          {{ this.sendOutData.hospital.name }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div
                        class="each-item"
                        v-if="
                          this.sendOutData &&
                          this.sendOutData.ordering_physician
                        "
                      >
                        <span class="name">Ordering Physician </span>
                        <span class="value">
                          {{ this.sendOutData.ordering_physician.name }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Accession ID </span>
                        <span class="value">
                          {{ this.sendOutData.accession_id }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="each-item">
                        <span class="name">Bill To </span>
                        <span class="value">
                          {{ this.sendOutData.billing_type }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <div
                        class="each-item"
                        v-if="this.sendOutData && this.sendOutData.icd_10_codes"
                      >
                        <span class="name">ICD-10 (Indicative) </span>
                        <span class="value case-type icd-code">
                          <span
                            v-for="(icdcode, index) in this.sendOutData
                              .icd_10_codes"
                            :key="index"
                            >{{ icdcode }}</span
                          >
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="each-step test-information"
              v-if="
                this.sendOutData &&
                this.sendOutData.tests_info &&
                this.sendOutData.tests_info.length
              "
            >
              <h3 class="step-title">Test Information</h3>

              <div
                class="each-item"
                v-for="(test, index) of getSelectedCaseTypes()"
                :key="index"
              >
                <span class="name pb-10">
                  {{ caseTypeMap[test.case_type_code] }}
                </span>
                <div v-if="test.case_type_code == 'TOXICOLOGY'">
                  <ToxicologyTestsPreview
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></ToxicologyTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOUND'">
                  <WoundPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></WoundPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'ENT'">
                  <EntPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></EntPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'NAIL'">
                  <NailPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></NailPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'GASTRO'">
                  <GastroPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GastroPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'UTI'">
                  <UTIPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UTIPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINE_CULTURE'">
                  <UrineCulturePanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UrineCulturePanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
                  <BloodPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></BloodPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'WOMENS_HEALTH'">
                  <WomensHealthSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></WomensHealthSelectedTests>
                </div>
                <div v-else>
                  <DefaultPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :testType="test"
                    :allSelectedTests="allTests"
                    :caseType="test.case_type_code"
                  ></DefaultPanelSelectedTests>
                </div>
              </div>
            </div>
            <div
              class="each-step patient-information"
              v-if="
                this.sendOutData &&
                this.sendOutData.medication &&
                this.sendOutData.medication.length
              "
            >
              <table>
                <tbody>
                  <tr>
                    <td colspan="4">
                      <h3 class="step-title">Medications</h3>
                    </td>
                  </tr>
                  <tr>
                    <td class="medications-list-flex">
                      <div
                        class="medications-list"
                        v-for="(medication, index) in this.sendOutData
                          .medication"
                        :key="index"
                      >
                        <span>{{ medication }} </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="each-step patient-information"
              v-if="
                this.sendOutData &&
                this.sendOutData.test_reports &&
                this.sendOutData.test_reports.length
              "
            >
              <table>
                <tbody>
                  <tr>
                    <td colspan="4">
                      <h3 class="step-title">Processing</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const EntPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/EntPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const UrineCulturePanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/UrineCulturePanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/ToxicologyTestsPreview"
  )
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/sendOuts/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const WomensHealthSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WomensHealthSelectedTests"
  )
);
export default {
  components: {
    WoundPanelSelectedTests,
    EntPanelSelectedTests,
    UTIPanelSelectedTests,
    UrineCulturePanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    NailPanelSelectedTests,
    GastroPanelSelectedTests,
    WomensHealthSelectedTests,
  },
  data() {
    return {
      sendOutData: {},
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      selectedTestIds: [],
      allTests: [],
      UTIPanels: [],
      selectedCoriellPanels: [],
      selectedTab: null,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      loading: false,
    };
  },
  computed: {
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("profile", ["getProfileData"]),
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },

    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
    getSelectedTestDetails() {
      if (
        this.getSendOutInformation.case_types &&
        this.getSendOutInformation.case_types.length
      ) {
        this.allTests.filter(
          (test) =>
            this.getSendOutInformation.case_types.indexOf(test.case_type) != -1
        );
      }
      return this.getSelectedCaseTypes();
    },
  },

  async mounted() {
    if (this.$route.params.sendout_id) {
      await this.checkSendOutCaseInformation();
    }
    setTimeout(() => {
      window.print();
    }, 1500);
    document.body.classList.add("send-out-print-page");
  },
  methods: {
    async checkSendOutCaseInformation() {
      try {
        this.loading = true;
        this.sendOutId = this.$route.params.sendout_id;
        await this.$store.dispatch("sendOuts/fetchSendOutInformation", {
          send_out_id: this.sendOutId,
        });
        if (this.getSendOutInformation) {
          this.sendOutData = this.getSendOutInformation;
        }
        if (
          this.getSendOutInformation &&
          this.getSendOutInformation.tests_info
        ) {
          this.panelsTestsData.selectedTestIds =
            this.getSendOutInformation.tests_info.map((el) => el._id);
        }

        this.allTests = this.getSendOutInformation.tests_info;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    getSelectedCaseTypes() {
      if (
        this.getSendOutInformation.case_types &&
        this.getSendOutInformation.case_types.length
      ) {
        let data = this.panelsTestsData.selectedCategories;
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
  },
  async unmounted() {
    document.body.classList.remove("send-out-print-page");
  },
};
</script>

<style lang="scss">
.send-out-print-page {
  .default-navbar {
    display: none;
  }
}
.test-information {
  .test-group-title {
    color: #34495e !important;
    font-size: 13px !important;
    text-decoration: underline;
    margin-bottom: 3px !important;
    font-weight: 600;
    padding-bottom: 3px;
    display: block;
    line-height: 20px;
  }
  .custom-tabs-label {
    span {
      color: #f24a58;
      font-size: 13px !important;
      text-decoration: underline;
      margin-bottom: 0;
      font-weight: 600;
      padding-bottom: 3px;
      display: block;
      line-height: 20px;
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    min-width: 900px;
    li {
      margin: 2px 5px !important;
      span {
        background: rgba(224, 224, 224, 0.4);
        border-radius: 7px;
        padding: 2px 10px;
        font-weight: 500;
        display: inline-block;
        font-size: 12px;
        color: #273480;
        margin: 3px 0;
        letter-spacing: 0;
      }
    }
  }
  .test-panels-blocks {
    .check-list {
      display: flex;
      flex-wrap: wrap;
      li {
        span {
          background: rgba(224, 224, 224, 0.4);
          border-radius: 7px;
          padding: 2px 10px;
          font-weight: 500;
          display: inline-block;
          font-size: 12px;
          color: #273480;
          margin: 3px 0;
          letter-spacing: 0;
        }
      }
    }
  }
  #uti-panel-selected .test-panels-blocks {
    min-height: auto !important;
    max-height: 100% !important;
    padding: 0 !important;
  }
}
</style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&display=swap");

* {
  font-family: "Poppins", sans-serif;
}

body {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  height: 100%;
  position: relative;
  z-index: 1;
}

@page {
  size: auto;
  margin: 30px;
}

td {
  padding: 0;
}

tr {
  padding: 0;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

@media print {
  body {
    background: none;
  }
}

.report-header {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 0 0 15px 0;
}

.report-header .logo {
  max-width: 200px;
  margin-bottom: 0;
}

.report-header .address p {
  font-size: 12.5px;
  line-height: 1.35;
  color: #444;
  margin: 0 0 3px;
  font-weight: 400;
}

.report-header .address p a {
  color: #f24a58;
}

.report-header .steps-inner-form td {
  font-size: 13px;
  color: #6d6c6c;
  line-height: 20px;
}

.report-header .steps-inner-form td.divider {
  font-size: 13px;
  color: #6d6c6c;
  padding: 0 10px;
}

.report-header .steps-inner-form td.value {
  font-weight: 500;
  color: #000;
  max-width: 190px;
}

#print-container {
  width: 900px;
  margin: 0 auto !important;
  position: relative;
  overflow: hidden;
  border: none;
}

#print-container .logo-navbar {
  margin: 10px 0;
}

#print-container .page-title {
  margin: 0;
  padding: 0 10px;
  background-color: #ececec;
  color: #184f68;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0;
}

#print-container .each-step {
  /* padding-bottom: 15px; */
  page-break-before: avoid;
}

#print-container .each-step .step-title {
  font-weight: 500;
  font-size: 15px;
  padding: 5px 10px;
  vertical-align: middle;
  background-color: #d1d2d4;
  margin: 7px 0;
  text-align: left;
  color: #000;
  border-radius: 4px;
}

#print-container .each-step table {
  width: 100%;
}

#print-container .each-step table td {
  vertical-align: top;
  width: 33.33%;
}

#print-container .each-step table td .each-item {
  padding: 5px 7px;
}

.test-information .each-item .name {
  margin-bottom: 5px;
  font-size: 16px !important;
}

.test-information table thead th {
  color: #008dc9;
  font-weight: 600;
  padding-bottom: 2px;
  display: block;
  line-height: 20px;
  background: #f2f2f2;
  padding: 5px;
}

.test-information table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.test-information table {
  border-collapse: collapse;
}

.test-information table tbody tr td {
  padding: 5px;
}

.each-test-information:not(:last-child) {
  margin-bottom: 25px;
}

.test-info-heading {
  background: #f9f9f9;
  color: #008dc9 !important;
  font-size: 15px !important;
  text-transform: uppercase !important;
  font-weight: 600 !important;
}

.test-information table tbody tr {
  page-break-inside: avoid;
}

.test-information table tbody tr td:nth-child(1) {
  width: 250px;
  color: #f24a58;
  font-size: 13px !important;
  /* text-decoration: underline; */
  margin-bottom: 0;
  font-weight: 500;
}

.test-information tbody tr td:nth-child(2) {
  width: auto;
  color: #000;
  font-size: 13px;
  font-weight: 500;
  display: block;
  line-height: 22px;
  word-spacing: 5px;
}

#print-container .each-step table td .name {
  font-size: 13px;
  color: #184f68;
  font-weight: 600;
  padding-bottom: 2px;
  display: block;
  line-height: 20px;
}

#print-container .each-step table td .value {
  color: #000;
  font-size: 14px;
  font-weight: 500;
  display: block;
  line-height: 20px;
  min-height: 20px;
}

#print-container .each-step.patient-information table td {
  width: 25%;
}

#print-container .each-step.test-information .each-item:not(:last-child) {
  margin-bottom: 15px;
}

#print-container .each-step.test-information span {
  display: block;
}

#print-container .each-step.test-information .each-item .each-item-value {
  page-break-inside: avoid;
  display: inline-block;
  width: 100%;
}

.payment-information {
  page-break-inside: avoid;
  display: inline-block;
  width: 100%;
}

#print-container .each-step.test-information .each-item {
  padding: 5px;
}

#print-container
  .each-step.test-information
  .each-item
  .each-item-value:not(:last-child) {
  margin-bottom: 10px;
}

#print-container .each-step.test-information .each-item .each-item-value .name {
  color: #f24a58;
  font-size: 13px !important;
  text-decoration: underline;
  margin-bottom: 0;
}

#print-container .each-step.test-information .name {
  font-size: 15px;
  color: #008dc9;
  font-weight: 600;
  padding-bottom: 3px;
  display: block;
  line-height: 20px;
}

#print-container .each-step.test-information .value {
  color: #000;
  /* font-size: 14px; */
  /* font-weight: 500; */
  line-height: 22px;
  /* word-spacing: 5px; */
  /* display: flex;
      flex-wrap: wrap; */
}

#print-container .each-step.test-information .value span {
  background: rgba(224, 224, 224, 0.4);
  border-radius: 7px;
  padding: 2px 10px;
  font-weight: 500;
  display: inline-block;
  font-size: 13.5px;
  color: #273480;
  margin: 3px 0;
  letter-spacing: 0;
}

#print-container .each-step.test-information .value span:not(:last-child) {
  margin-right: 5px;
}

#print-container .each-step.payment-information .insurance-state p {
  margin-bottom: 0;
  color: #000;
  font-weight: 500;
}

#print-container .each-step.payment-information .insurance-state p span {
  background: #f89a9a;
  padding: 1px 8px;
  border-radius: 1px;
}

#print-container .each-step.payment-information .insurance-state p span.yes {
  background: #008dc9;
  color: #fff;
}

#print-container .each-step.payment-information h5 {
  font-size: 14px;
  color: #008dc9;
  margin: 0;
  padding-top: 10px;
  font-weight: 600;
  margin-bottom: 10px;
  text-decoration: underline;
}

#print-container .each-step.payment-information table td {
  width: 25%;
}

#print-container .each-step.disclaimer {
  page-break-inside: avoid;
}

#print-container .each-step.disclaimer .value {
  font-size: 12.5px;
}

#print-container .each-step.disclaimer p {
  font-family: "Roboto", sans-serif;
  letter-spacing: 0;
  margin: 0 0 10px 0;
  line-height: 140%;
}

#print-container .each-step.icd-information {
  page-break-inside: avoid;
}

#print-container .each-step.icd-information table td,
#print-container .each-step.medication-information table td,
#print-container .each-step.disclaimer table td {
  width: 100%;
}

#print-container .each-step.medication-information {
  page-break-inside: avoid;
}

#print-container .each-step.signature-step {
  border: none;
  page-break-inside: avoid;
  page-break-before: auto !important;
  page-break-after: always;
  display: inline-block;
  width: 100%;
  padding: 10px;
}

#print-container .each-step.signature-step p {
  color: #333;
  font-size: 11px;
  font-weight: 500;
  display: block;
  line-height: 20px;
  margin: 0;
  margin-top: 5px;
  text-align: justify;
}

#print-container .each-step.signature-step table tr td {
  width: 50%;
}

#print-container .each-step.signature-step table tr td:nth-child(2) .each {
  display: block;
  float: right;
}

#print-container .each-step.signature-step .each {
  width: 250px;
  text-align: center;
}

#print-container .each-step.signature-step .each .signature {
  margin-bottom: 10px;
  height: 65px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
}

.each-item.signature .name {
  color: #f24a58 !important;
  font-weight: 600 !important;
  margin: 0 !important;
}

#print-container .each-step.signature-step .each .signature img {
  width: 140px;
  display: table;
  margin: 0 auto;
  margin-right: -10px;
}

#print-container .each-step.signature-step .each h5 {
  color: #f24a58;
  font-weight: 600;
  margin: 0;
}

.separate-page {
  page-break-before: auto !important;
  page-break-inside: avoid;
  page-break-after: always;
}

.break-before {
  page-break-before: auto !important;
  page-break-inside: avoid;
  page-break-after: always;
}

.uti .each-item p,
.claims p {
  margin: 0;
  font-size: 14px;
}

.signature .value {
  margin-bottom: 10px;
  height: 65px;
  width: 250px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
}

.others .value {
  /* margin-bottom: 10px; */
  min-height: 65px !important;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
}
/* Styles go here */
.page-header,
.page-header-space {
  height: 175px;
}

.page-header {
  position: relative;
}

.page-header-space {
  display: none;
}

@media print {
  .page-header {
    position: fixed;
    top: 0;
    width: 900px;
    margin: 0 auto;
  }

  .page-header-space {
    display: block;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }
}

.each-check-box {
  text-align: left;
}

.each-check-box .form-group {
  display: block;
  /* margin-bottom: 7px; */
}

.each-check-box .form-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.each-check-box .form-group label {
  position: relative;
  cursor: pointer;
  font-size: 12px;
}

.each-check-box .form-group label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #0079bf;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 5px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 7px;
  border-radius: 2px;
}

.each-check-box .form-group input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: -1px;
  left: 6px;
  width: 4px;
  height: 12px;
  border: solid #0079bf;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.case-type span {
  background: rgba(224, 224, 224, 0.4);
  border-radius: 7px;
  padding: 2px 10px;
  font-weight: 500;
  display: inline-block;
  font-size: 12px;
  color: #273480;
  margin: 3px 0;
  letter-spacing: 0;
}
.case-type span:not(:last-child) {
  margin-right: 5px;
}
.medications-list-flex {
  display: grid;
  grid-template-columns: repeat(4, 24%);
  width: 100% !important;
  row-gap: 10px;
  column-gap: 10px;
  .medications-list {
    span {
      background: rgba(224, 224, 224, 0.4);
      border-radius: 7px;
      padding: 2px 10px;
      font-weight: 500;
      display: inline-block;
      font-size: 13.5px;
      color: #273480;
      margin: 3px 0;
      letter-spacing: 0;
      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
@media print {
  .default-navbar {
    display: none;
  }
}
</style>
